import httpClient from "@/services/httpClient";
import {
    server
} from "@/services/constants";

export const getAllDotypeAction = () => {
    return httpClient.get(server.DOCTYE_ACTIONS + `/getAll`);
};
export const getbyobjectgroup_id = (objectgroup_id) => {
    return httpClient.get(server.DOCTYE_ACTIONS + `/getbyobjectgroup_id/${objectgroup_id}`);
};